

export const SUBSCRIBED_USER_PAYMENT_INVITE_FEE_PERCENTAGE = 7;

export const NON_SUBSCRIBED_USER_PAYMENT_INVITE_FEE_PERCENTAGE = 9;